import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import ActiveFiltersChips from './ActiveFiltersChips'
import { TranslateContext } from 'client/common/translator'
import { Link } from 'chemistry'

const ActiveFilters = ({ collection, onRemove, onClear }) => {
  const t = useContext(TranslateContext)

  return (
    <div className='mxd-active-filters-side'>
      <b className='lg-only col-12'>{t('lister.filters.selected_filters')}</b>
      <ActiveFiltersChips collection={collection} onRemove={onRemove} />
      <Link as='button' w='100%' d='flex' className='lg-only' onClick={e => onClear(e)}>
        {t('lister.filters.clear_filters')}
      </Link>
    </div>
  )
}

ActiveFilters.propTypes = {
  collection: PropTypes.array,
  onRemove: PropTypes.func,
  onClear: PropTypes.func
}

export default ActiveFilters
